import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import ThreeDModel from "../ExtraComponents/ThreeDModel";
import ThreeDText from "../ExtraComponents/ThreeDText";
import Projects from "../ExtraComponents/Projects";

// importing icons
import { FaGithub } from 'react-icons/fa';
import { DiCss3, DiHtml5, DiReact, DiJavascript1, DiPython, DiSqllite } from 'react-icons/di';
import { BiLogoFlask } from 'react-icons/bi';

export default function Homepage() {
    // loads different parts of the webpage as the page is scrolled
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('in-view')
                } else {
                    entry.target.classList.remove('in-view')
                }
            })
        }, {
            rootMargin: '0px',
            threshold: [0, 0.1, 1]
        })
        
        const tags = document.querySelectorAll('div, h1, h2, h3, h4, p')
        tags.forEach((tag) => {
            observer.observe(tag)
        })
    }, [])

    // dont use p tags in jsx code
    return (
        <main>
            <Navbar />
            <div id='home' className="landing-page">
                <h1>Hey! 🤙🏼</h1>
                <h2>I'm Michael Jeung, a</h2>
                <br></br>
                <ThreeDText />
            </div>
            {/* <ThreeDModel /> */}
            <div id="about" className="about">
                <div className="about-text">
                    <h2>About Me</h2>
                    <h5>
                        I am a bootcamp graduate and currently creating a more diverse portfolio to showcase my abilities!
                        Check into my website to see any project updates and newly created ones as well!
                        Transitioning into the tech indrusty after being in the food service industry is daunting, but not impossible to achieve.
                        I hope that eventually I will be able to reach the heights I set for myself moving forward in this new industry.
                    </h5>
                    <h5>
                        Whenever I have some time to myself, you can find me going on solo bike rides or just playing sports with friends.
                        Lately I've been getting into coding or just chatting with new people I meet in the blur that is my life.
                    </h5>
                    <h2>Skills</h2>
                    <ul className="skills-list">
                        <li>HTML<DiHtml5/></li>
                        <li>CSS<DiCss3/></li>
                        <li>JavaScript<DiJavascript1/></li>
                        <li>React<DiReact/></li>
                        <li>Python<DiPython/></li>
                        <li>Flask<BiLogoFlask/></li>
                        <li>React-Native</li>
                        <li>SQLite<DiSqllite /></li>
                    </ul>
                </div>
            </div>
            <div id="experience">
                <h2>Working Experience</h2>
                <br></br>
                <h3>Freelance Web Developer</h3>
                <h5>2023 - Present</h5>
                <h3>Kaigo Coffee Room</h3>
                <h5>2019 - Present</h5>
                <h3>Cafe Joah</h3>
                <h5>2023 - Present</h5>
                <h3>Coffee Shop Consultant</h3>
                <h5>2022 - Present</h5>
            </div>
            <div id="all-projects">
                <h2>PROJECTS</h2>
                <div className='project'>
                    <h3>
                        FlatBuy
                        <a href='https://github.com/mdbj12/FlatBuy'><FaGithub/></a>
                    </h3>
                    <h5>An E-commerce web application where users can buy/sell items, login/logout via Google, write reviews/ratings for items and checkout what is in their cart.</h5>
                </div>
                <div className="project">
                    <h3>
                        Ghost Writer
                        <a href="https://github.com/mdbj12/GhostWriter"><FaGithub/></a>
                    </h3>
                    <h5>A Python based CLI application where users are prompted to create and login to user, then create, review, rate and see books that are stored.</h5>
                </div>
                <div className="project">
                    <h3>
                        Fog of Maps
                        <a href='https://github.com/mdbj12/Capstone'><FaGithub/></a>
                    </h3>
                    <h4>Under Development ... 🛠️</h4>
                    <h5>A React-Native based mobile application that tracks the users location and clears a 'fog' wherever the user has traveled.</h5>
                </div>
                <div className="project">
                    <h3>My Blog!
                        <a href="https://github.com/mdbj12/Blog"><FaGithub/></a>
                        <a href="https://michaels-blog-fj1i.onrender.com/#home"></a>
                    </h3>
                    <h4>Under Development ... 🛠️</h4>
                    <h5>Just a place for me to mess around with 3JS, Blender Animations and post random thoughts!</h5>
                </div>
                <div className="project">
                    <h3>Barista Basics
                        <a href="https://github.com/mdbj12/Barista-Basics"><FaGithub/></a>
                        <a href="https://barista-basics.vercel.app/"></a>
                    </h3>
                    <h4>Under Development ... 🛠️</h4>
                    <h5>
                        An app built using NextJs, to teach anyone to learn how to make coffee as a cafe would!
                        Learn different ways to brew coffee that can easily be done with inexpensive equipment!
                    </h5>
                </div>
                {/* <Projects /> */}
            </div>
        </main>
    )
}
